export default "__VITE_ASSET__Chb97un___"